import Vue from 'vue'

const env = {
  appName: process.env.VUE_APP_NAME,
  apiUrl: process.env.VUE_APP_API_URL,
  /* Places */
  placesApiKey: process.env.VUE_APP_PLACES_API_KEY,
  /* Google Sign-in */
  googleSigninClientId: process.env.VUE_APP_GOOGLE_SIGNIN_CLIENT_ID,
  /* Firebase */
  firebaseApiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  firebaseAuthDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  firebaseDatabaseUrl: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  firebaseProjectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  firebaseMessagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
  firebaseAppId: process.env.VUE_APP_FIREBASE_APP_ID,
  /* Stripe */
  stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
  stripeSecretKey: process.env.VUE_APP_STRIPE_SECRET_KEY
}

Vue.prototype.$env = env

export default env
